import { publicUrl } from "@hooks"
export const searchHashtags =async (name:string) => {
    return await  publicUrl.post("Hashtags/Search",{name});
}